export default "__VITE_ASSET__BggcdLm0__"